define('home/mixins/asEmbedApp',[
    'jquery',
    'underscore',

    'core/api',
    'core/frameBus',
    'core/bus',
    'core/utils',

    'home/utils/navigationUtils',
], function (
    $,
    _,

    api,
    FrameBus,
    coreBus,
    coreUtils,

    NavigationUtils
) {
    'use strict';

    // Will be resolved once the sidebar is open. This is pretty hacky right now.
    // TODO: find a way to attach this variable to either the Router or the Session instance.
    var _showPathReceived;

    /**
     * A mixin around the Router that handles special cases for
     * showing the home app in the sidebar
     */
    var asEmbedRouter = {
        initialize: function (_initialize) {

            _showPathReceived = $.Deferred();

            this.name = 'embed_sidebar';

            // deferred object that gets resolved when the mainLayout onDomRefresh
            // event is triggered
            this.mainLayoutIsRendered = $.Deferred();
            this.listenTo(FrameBus, 'mainlayoutRendered', this.mainLayoutIsRendered.resolve);

            this.listenTo(coreBus, 'after:render', function () {
                FrameBus.sendHostMessage('after:render');
            });

            _initialize.apply(this, _.rest(arguments));

            // first message received from host to load data.
            this.listenTo(FrameBus, 'showPath', this.loadPath);

            // once openReady is sent to embed, embed will send back
            // a open event when the iframe is being shown
            this.listenTo(FrameBus, 'open', this.openDrawer);

            // send back ready message to let embed know we are
            // ready to receive messages
            FrameBus.sendHostMessage('ready');

        },

        initUserProfile: function (_initUserProfile) {
            _showPathReceived.done(_initUserProfile);
        },

        // We don't need moderated forums list in the Embed at all.
        loadModeratedForums: $.noop,

        setSsoHeaders: function (sso) {
            api.headers({
                'X-Disqus-Publisher-API-Key': sso.apiKey,
                'X-Disqus-Remote-Auth': sso.remoteAuthS3,
            });
        },

        /**
         * Manually routes the user to the path, so we don't need to
         * reload the entire page. loadPath is called when the embed
         * sends a 'showPath' message to the home iframe.
         *
         * @param {Object} data - Host configuration data
         */
        loadPath: function (data) {
            // If sso and credentials present, set headers.
            // This must be done before anything else in this function.
            if (data.sso && data.sso.apiKey && data.sso.remoteAuthS3) {
                this.setSsoHeaders(data.sso);
                this.isSSOAuthenticated = true;
            }

            _showPathReceived.resolveWith(this);

            this.disableMOTD = data.disableMOTD;

            this.mainLayoutIsRendered.done(function () {
                NavigationUtils.navigate(data.path, { trigger: true });
                FrameBus.sendHostMessage('openReady');
            });
        },

        openDrawer: function () {
            var $body = $('body');
            $body.addClass('active');
            $body.one(coreUtils.transitionEndEvent, function () {
                FrameBus.sendHostMessage('after:render');
                window.document.querySelector('a').focus();
            });
        },
    };

    /**
     * A mixin around the Session model that defers server fetches
     * until the sidebar has been opened
     */
    var asEmbedSession = {
        initialize: function (_initialize) {
            this.listenToOnce(FrameBus, 'setForum', function (shortname) {
                this.forum = { shortname: shortname };
            });

            _initialize.apply(this, _.rest(arguments));
        },

        fetch: function (_fetch, options) {
            return _showPathReceived.then(_.bind(_fetch, this, options));
        },

        fetchFollowedForums: $.noop,
        fetchFollowedChannels: $.noop,
    };

    /**
     * Adds mixins to various classes to support showing the
     * home app in the sidebar.
     *
     * TODO: probably a good idea to find a way to not do a mixin
     *       that takes two prototypes. OR, we could do _all_ of the
     *       asEmbed prototypes here. Food for thought ...
     *
     * @param  {Class} Router - The prototype for the Router
     * @param  {Class} Session - The prototype for the Session
     */
    var asEmbedApp = function (Router, Session) {
        // Mixin asEmbedRouter into the Router prototype
        Router.initialize = _.wrap(Router.initialize, asEmbedRouter.initialize);
        Router.initUserProfile = _.wrap(Router.initUserProfile, asEmbedRouter.initUserProfile);

        Router.loadModeratedForums = asEmbedRouter.loadModeratedForums;
        Router.setSsoHeaders = asEmbedRouter.setSsoHeaders;
        Router.loadPath = asEmbedRouter.loadPath;
        Router.openDrawer = asEmbedRouter.openDrawer;
        Router.navigateToPath = asEmbedRouter.navigateToPath;
        Router.isSSOAuthenticated = asEmbedRouter.isSSOAuthenticated;


        // Mixin asEmbedSession into the Session prototype
        Session.initialize = _.wrap(Session.initialize, asEmbedSession.initialize);
        Session.fetch = _.wrap(Session.fetch, asEmbedSession.fetch);
        Session.fetchFollowedForums = asEmbedSession.fetchFollowedForums;
        Session.fetchFollowedChannels = asEmbedSession.fetchFollowedChannels;
    };

    return asEmbedApp;
});

